import AbstractManageable from './abstract-manageable';
import LocalAuthority     from './local-authority';

export default class Result extends AbstractManageable {

	/**
     * @param {LocalAuthority} localAuthority
	 * @param {Boolean}        operation
	 * @param {Number}         amount
     * @param {Number}         year
	 */
	constructor(
			localAuthority,
			operation,
			amount,
			year,
			creator,
			createdAt,
			updater,
			updatedAt
            ) {
		super(creator, createdAt, updater, updatedAt);

		this.year           = year;
		this.amount         = amount;
		this.localAuthority = localAuthority;
		this.operation      = operation;
	}

	static createFromJson = (json) => {
		if (!json) return null;

		return new Result(
			LocalAuthority.createFromJson(json.localAuthority),
            json.operation,
            json.amount,
            json.year
		);
	}
}


// WEBPACK FOOTER //
// ./src/model/result.js